module.exports = __webpack_public_path__ + "img/es.661d1fe3.svg";